"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportWebVitals = reportWebVitals;
exports.trackCoreWebVitals = trackCoreWebVitals;
// import { onLCP, onFID, onCLS, onINP, onFCP, onTTFB } from 'web-vitals/attribution' // Removing `webVitalsAttribution` Feature in next.config.json
const web_vitals_1 = require("next/dist/compiled/web-vitals");
const { APP_ENV } = process.env;
const isDev = APP_ENV === 'local';
function reportMetric(metric) {
    var _a, _b;
    if (isDev) {
        // The metric object ({ id, name, startTime, value, label }) is logged to the console
        // console.log('Web Vitals', { metric })
        return;
    }
    /*
      In addition to the core metrics listed above, there are some additional custom metrics that measure the time it takes for the page to hydrate and render:
      Next.js-hydration: Length of time it takes for the page to start and finish hydrating (in ms)
      Next.js-route-change-to-render: Length of time it takes for a page to start rendering after a route change (in ms)
      Next.js-render: Length of time it takes for a page to finish render after a route change (in ms)
    */
    if (typeof window !== 'undefined') {
        const { id, name, value, attribution } = metric;
        window.dataLayer.push({
            event: `web vitals ${name}`,
            // Google Analytics metrics must be integers, so the value is rounded.
            // For CLS the value is first multiplied by 1000 for greater precision
            // (note: increase the multiplier for greater precision if needed).
            vitals: Math.round(name === 'CLS' ? value * 1000 : value),
            // values must be integers
            // The `id` value will be unique to the current page load. When sending
            // multiple values from the same page (e.g. for CLS), Google Analytics can
            // compute a total by grouping on this ID (note: requires `eventLabel` to
            // be a dimension in your report).
            id,
            // id unique to current page load
            // CLS
            attributionElement: (_b = (_a = attribution === null || attribution === void 0 ? void 0 : attribution.largestShiftTarget) !== null && _a !== void 0 ? _a : attribution === null || attribution === void 0 ? void 0 : attribution.element) !== null && _b !== void 0 ? _b : '',
        });
    }
}
// Next.js calls this with its own custom timing metrics (hydration / render).
// It must be re-exported as a named export from pages/_app for Next.js to find it.
function reportWebVitals(metric) {
    if (metric.label === 'custom') {
        // Only track custom metrics. For Web Vitals, we use the `web-vitals` package directly,
        // as it’s newer than what ships with Next.js 12.3.
        reportMetric(metric);
    }
}
// Track core Web Vitals. This could be removed once we upgrade to Next.js 13
// (which includes https://github.com/vercel/next.js/pull/39368)
function trackCoreWebVitals() {
    if (typeof window === 'undefined')
        return;
    (0, web_vitals_1.onLCP)(reportMetric);
    (0, web_vitals_1.onFID)(reportMetric);
    (0, web_vitals_1.onCLS)(reportMetric);
    (0, web_vitals_1.onINP)(reportMetric);
    (0, web_vitals_1.onFCP)(reportMetric);
    (0, web_vitals_1.onTTFB)(reportMetric);
}
